














































































































import Agency from "@/store/entities/agency";
import { Component, Vue } from "vue-property-decorator";
import AddAgency from "./modals/addAgency.vue";

@Component({
  components: { AddAgency },
})
export default class Agencies extends Vue {
  search: string = "";
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  agencies: Agency[] = [];

  created() {
    this.getAgency();
    (this.headers = [
      { text: "Acente Adı", value: "name" },
      { text: "İrtibat", value: "contact" },
      { text: "Ülke", value: "country" },
      { text: "Şehir", value: "city" },
      { text: "Bölge", value: "district" },
      { text: "Para Birimi", value: "currency" },
      { text: "E-Posta", value: "email" },
      { text: "Telefon", value: "phone" },
      { text: "Sağlayıcı", value: "isProvider" },
      { text: "İşlemler", value: "transactions" },
    ]),

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Tanımlamalar", disabled: true },
      { text: "Acenteler", disabled: true },
    ];
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }

  async getAgency() {
    await this.$store.dispatch({
      type: "agency/getAgency",
    });

    this.agencies = this.$store.state.agency.list;
  }

  editAgency(item) {
    this.$store.state.agency.editAgency = item;
    this.isOpenModal = true;
  }

  async deleteAgency(item) {
    await this.$store
      .dispatch({
        type: "agency/deleteAgency",
        payload: item.id,
      })
      .then((x) => {
        this.getAgency();
      });
  }

  confirmDelete(item) {
    this.$swal({
      title: "Satır Silinecetir.",
      text: "İşlemi Devam Ettirmeye Emin misiniz?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Evet",
      cancelButtonText: "Hayır",
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteAgency(item);
        Vue.$toast.success("Silme Başarılı");
      }
    });
  }
  openModal() {
    this.$store.state.agency.editAgency = null;
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getAgency();
  }

  cancelModal() {
    this.isOpenModal = false;
  }
}
